@if (linkConfig) {
  <ui-button
    class="link"
    [mkpDataTest]="linkDataTest ?? linkConfig?.content?.dataTest"
    [state]="linkConfig.state"
    [config]="linkConfig.config"
    [routerLink]="linkConfig.content.url"
  >
    {{ linkConfig.content.label | translate }}
  </ui-button>
}

@if (primaryConfig) {
  <ui-button
    [mkpDataTest]="primaryDataTest ?? primaryConfig?.content?.dataTest"
    [trackingValue]="primaryTrackingValue"
    [state]="primaryConfig.state"
    [config]="primaryConfig.config"
    [loading]="isLoading || isCancellableLoading"
    [disabled]="isLoading || isCancellableLoading"
    (click)="handlePrimaryClick.emit()"
  >
    <span
      [ngClass]="{
        'hidden-text': isLoading || isCancellableLoading,
        'label-with-icon': primaryConfig.content.iconName,
      }"
    >
      @if (primaryConfig.content.iconName) {
        <ui-asset [name]="primaryConfig.content.iconName" />
      }
      {{ primaryConfig.content.label | translate }}
    </span>
  </ui-button>
}
@if (secondaryConfig) {
  <ui-button
    [mkpDataTest]="secondaryDataTest ?? secondaryConfig?.content?.dataTest"
    [config]="secondaryConfig.config"
    [disabled]="isLoading"
    (click)="handleSecondaryClick.emit()"
  >
    {{ secondaryConfig.content.label | translate }}
  </ui-button>
}

@if (tertiaryConfig) {
  <ui-button
    class="tertiary"
    [mkpDataTest]="tertiaryDataTest ?? tertiaryConfig?.content?.dataTest"
    [config]="tertiaryConfig.config"
    (click)="handleTertiaryClick.emit()"
  >
    @if (tertiaryConfig.content.iconName) {
      <ui-asset [name]="tertiaryConfig.content.iconName" />
    }
    {{ tertiaryConfig.content.label | translate }}
  </ui-button>
}
